import React, { Component } from "react";
import Head from "next/head";
import NProgress from "components/NProgress";
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ReactPixel from 'react-facebook-pixel';
import Typography from '@material-ui/core/Typography';
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile,
    isIOS,
    IOSView,
} from "react-device-detect";
// import TagManager from 'react-gtm-module'
import SeoMeta from '/components/seoMeta';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBullhorn } from '@fortawesome/free-solid-svg-icons';

// const tagManagerArgs = {
//     gtmId: 'GTM-WCJSTPT',
// }

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    card: {
        minWidth: 275,
    },
    JobsTitle:{color: theme.palette.primary.main,
        textAlign: 'center',
        fontWeight: 'bold',
        margin: '12px 0',

    },
    jobDescription:{
        textAlign: 'center',
        backgroundColor: theme.palette.primary.main,
        padding: 25,
        color: 'white',
        margin: 0
    },
    cardContentIFrame:{
        padding: 0,
        overflow: isIOS ? 'scroll' : 'hidden',
        width: '100%',
        overflowScrolling: "touch",
        WebkitOverflowScrolling: "touch",
        textAlign: 'center',
        paddingTop: '12px'
    },
    myjobIOSIFrame:{
        width: '94%',
        [theme.breakpoints.down('sm')]: {
            width: isIOS ? '393px' : '94%',
        },
        [theme.breakpoints.up('md')]: {
            width: '94%',
        },
    },
});

class Jobs extends Component{
  constructor(props){
     super(props);
     this.state = {
        ssrDone: false,
     };

  }

render(){
 const { classes } = this.props;
 const ssrDone = this.state.ssrDone;
 return(
    <div>
        <Head>
            <title>Jobs</title>
        </Head>
        <SeoMeta
            url={`${process.env.BACKEND_URL}/jobs`}
            type="article"
            title='Jobs'
            description="Hiring jobs position of Duwun"
            image='https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/duwun-news-logo.jpg'
            section='jobs'
            keywords='jobs'
          />        
        <NProgress />
        <div className={classes.root}>
            <Typography component="h3" variant="h6" className={classes.JobsTitle} gutterBottom>
            WE'RE HIRING NOW! <FontAwesomeIcon icon={faBullhorn} />
            </Typography>
            <Grid container
            direction="row"
            justify="center"
            alignItems="center">
                <Grid item xs={12}>
                    <Card className={classes.card}>
                        {/* <Typography component="h1" variant="h6" className={classes.jobDescription} gutterBottom>
                            We're Hiring
                        </Typography> */}
                        <CardContent className={classes.cardContentIFrame}>
                            <iframe id="typeform-full"
                                className={classes.myjobIOSIFrame}
                                width="94%" height="730px" frameBorder="0"
                                src="https://duwun-data.sgp1.cdn.digitaloceanspaces.com/static/myjobs/duwun-hiring-jobs.html"></iframe>
                        </CardContent>
                        <br />
                        <br />
                    </Card>
                </Grid>
            </Grid>
        </div>
    </div>
        )
    }
    componentDidMount () {

        // ************ start facebook pixel ***********

        if (!window.PX_INITIALIZED) {
            const advancedMatching = { em: '' }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/pixel-with-ads/conversion-tracking#advanced_match
            const options = {
                autoConfig: true, 	// set pixel's autoConfig
                debug: false, 		// enable logs
            };
            ReactPixel.init('548709379041005', advancedMatching, options);
            // ReactPixel.init('355678948310337', advancedMatching, options);
            window.PX_INITIALIZED = true
        }
        ReactPixel.track('ViewContent', {
            content_name: 'Duwun Jobs',
            content_category: 'Jobs',
            content_ids: ['jobs'],
            content_type: 'JOBS',
            value: 1,
            currency: 'USD'
        })
        //  ReactPixel.pageView(); 					// For tracking page view
        //  ReactPixel.track( event, data ) 		// For tracking default events, more info about events and data https://developers.facebook.com/docs/ads-for-websites/pixel-events/v2.9
        //  ReactPixel.trackCustom( event, data ) 	// For tracking custom events
        // ************ end facebook pixel ***********
        this.setState({
            ssrDone: true,
        });
    }

    componentDidUpdate(previousProps, previousState){
        // TagManager.dataLayer(tagManagerArgs)
    }
  }


export default withStyles(styles)(Jobs);
